var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSlides = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 14,
  height: 14,
  fill: "none",
  viewBox: "0 0 14 14"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M7.5 1v1H13a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H7.707l2.647 2.646-.708.708L7 10.707l-2.646 2.647-.708-.708L6.293 10H1a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h5.5V1h1z",
  clipRule: "evenodd"
})));
export { SvgSlides as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNCIgaGVpZ2h0PSIxNCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDE0IDE0Ij4KICAgIDxwYXRoIGZpbGw9ImN1cnJlbnRDb2xvciIgZmlsbC1ydWxlPSJldmVub2RkIiBkPSJNNy41IDF2MUgxM2ExIDEgMCAwIDEgMSAxdjZhMSAxIDAgMCAxLTEgMUg3LjcwN2wyLjY0NyAyLjY0Ni0uNzA4LjcwOEw3IDEwLjcwN2wtMi42NDYgMi42NDctLjcwOC0uNzA4TDYuMjkzIDEwSDFhMSAxIDAgMCAxLTEtMVYzYTEgMSAwIDAgMSAxLTFoNS41VjFoMXoiIGNsaXAtcnVsZT0iZXZlbm9kZCIvPgo8L3N2Zz4K";